import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d56e3980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-correspondence" }
const _hoisted_2 = { class: "general-accounts" }
const _hoisted_3 = { class: "table-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Correspondence"),
  /*#__PURE__*/_createElementVNode("h2", null, "View correspondence")
], -1))
const _hoisted_5 = { class: "__right" }
const _hoisted_6 = { class: "ls-table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { "data-label": "Type" }
const _hoisted_14 = { "data-label": "Date received" }
const _hoisted_15 = { "data-label": "Description" }
const _hoisted_16 = { "data-label": "Filename" }
const _hoisted_17 = { "data-label": "Actions" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditCorrespondenceModal = _resolveComponent("AddEditCorrespondenceModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.openAddEditCorrespondence({id: 0})))
          }, "Add Correspondence")
        ])
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correspondenceHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", {
                  colspan: _ctx.correspondenceHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_8)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", {
                    colspan: _ctx.correspondenceHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_10)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.correspondences.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _createElementVNode("td", {
                      colspan: _ctx.correspondenceHeadings.length
                    }, "No Records", 8, _hoisted_12)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.correspondences.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.correspondences, (c) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(c.correspondenceType.name), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(c.dateReceived ? _ctx.$formatDate(c.dateReceived) : ''), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(c.correspondenceDescription?.id == 13 ? c?.description : c.correspondenceDescription?.name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(c.file?.fileName), 1),
                        _createElementVNode("td", _hoisted_17, [
                          (c.file)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-default sml ml-1 mr-1",
                                onClick: $event => (_ctx.downloadFile(c))
                              }, "Download", 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.openAddEditCorrespondence(c))
                          }, "Edit", 8, _hoisted_19)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showCorrespondenceModal)
      ? (_openBlock(), _createBlock(_component_AddEditCorrespondenceModal, {
          key: 0,
          correspondence: _ctx.selectedCorrespondence,
          onCloseAddEditCorrespondenceModal: _cache[1] || (_cache[1] = $event => (_ctx.closeAddEditCorrespondence()))
        }, null, 8, ["correspondence"]))
      : _createCommentVNode("", true)
  ]))
}